export const websiteTraffic = {
  objectives: [
    {
      deleted: false,
      lastProcessedBlock: 63672478,
      _id: "66dfff408effa6bd74302650",
      chainId: 137,
      contractAddress: "0x5d75B268CD11d9E72DfCBfb88ebe892Fbc6A485a",
      entity: "66c8189a5fb810015d64d11e",
      eventName: "Deposit",
      __v: 0,
      created: "2024-09-10T08:26:52.840Z",
      eventABI:
        '[\n\t{\n\t\t"inputs": [],\n\t\t"stateMutability": "nonpayable",\n\t\t"type": "constructor"\n\t},\n\t{\n\t\t"anonymous": false,\n\t\t"inputs": [\n\t\t\t{\n\t\t\t\t"indexed": true,\n\t\t\t\t"internalType": "address",\n\t\t\t\t"name": "_user",\n\t\t\t\t"type": "address"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"indexed": true,\n\t\t\t\t"internalType": "address",\n\t\t\t\t"name": "_stakingToken",\n\t\t\t\t"type": "address"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"indexed": true,\n\t\t\t\t"internalType": "address",\n\t\t\t\t"name": "_receiptToken",\n\t\t\t\t"type": "address"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"indexed": false,\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_amount",\n\t\t\t\t"type": "uint256"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"indexed": false,\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_pid",\n\t\t\t\t"type": "uint256"\n\t\t\t}\n\t\t],\n\t\t"name": "Deposit",\n\t\t"type": "event"\n\t},\n\t{\n\t\t"anonymous": false,\n\t\t"inputs": [\n\t\t\t{\n\t\t\t\t"indexed": true,\n\t\t\t\t"internalType": "address",\n\t\t\t\t"name": "_user",\n\t\t\t\t"type": "address"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"indexed": true,\n\t\t\t\t"internalType": "address",\n\t\t\t\t"name": "_stakingToken",\n\t\t\t\t"type": "address"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"indexed": true,\n\t\t\t\t"internalType": "address",\n\t\t\t\t"name": "_receiptToken",\n\t\t\t\t"type": "address"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"indexed": false,\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_amount",\n\t\t\t\t"type": "uint256"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"indexed": false,\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_pid",\n\t\t\t\t"type": "uint256"\n\t\t\t}\n\t\t],\n\t\t"name": "Withdraw",\n\t\t"type": "event"\n\t},\n\t{\n\t\t"inputs": [\n\t\t\t{\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_boost",\n\t\t\t\t"type": "uint256"\n\t\t\t}\n\t\t],\n\t\t"name": "boost",\n\t\t"outputs": [],\n\t\t"stateMutability": "nonpayable",\n\t\t"type": "function"\n\t},\n\t{\n\t\t"inputs": [\n\t\t\t{\n\t\t\t\t"internalType": "address",\n\t\t\t\t"name": "_stakingToken",\n\t\t\t\t"type": "address"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_pid",\n\t\t\t\t"type": "uint256"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_amount",\n\t\t\t\t"type": "uint256"\n\t\t\t}\n\t\t],\n\t\t"name": "deposit",\n\t\t"outputs": [],\n\t\t"stateMutability": "nonpayable",\n\t\t"type": "function"\n\t},\n\t{\n\t\t"inputs": [\n\t\t\t{\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_pid",\n\t\t\t\t"type": "uint256"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_amount",\n\t\t\t\t"type": "uint256"\n\t\t\t}\n\t\t],\n\t\t"name": "emrgencyWithdraw",\n\t\t"outputs": [],\n\t\t"stateMutability": "nonpayable",\n\t\t"type": "function"\n\t},\n\t{\n\t\t"inputs": [\n\t\t\t{\n\t\t\t\t"internalType": "address",\n\t\t\t\t"name": "_stakingToken",\n\t\t\t\t"type": "address"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_pid",\n\t\t\t\t"type": "uint256"\n\t\t\t},\n\t\t\t{\n\t\t\t\t"internalType": "uint256",\n\t\t\t\t"name": "_amount",\n\t\t\t\t"type": "uint256"\n\t\t\t}\n\t\t],\n\t\t"name": "withdraw",\n\t\t"outputs": [],\n\t\t"stateMutability": "nonpayable",\n\t\t"type": "function"\n\t}\n]',
      updated: "2024-09-10T08:26:52.840Z",
    },
  ],
  referrer: {
    success: true,
    total: 419,
    page: 1,
    pageSize: 5,
    refererData: [
      {
        referer: "Direct traffic",
        totalUser: 1595,
        walletsConnected: 1162,
        objectiveAchieved: 84,
        achievedWallets: [
          {
            walletAddress: "0x7303370EfC291a3E07445bfC849f5b72d88Bc94B",
            txs: [
              {
                walletAddress: "0x7303370EfC291a3E07445bfC849f5b72d88Bc94B",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x23219850870d18546D3e3c3e74e1f9CEf918442c",
            txs: [
              {
                walletAddress: "0x23219850870d18546D3e3c3e74e1f9CEf918442c",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x4E9051dE9dfaB338bA5D00d42718AC3ef6F0EC3D",
            txs: [
              {
                walletAddress: "0x4E9051dE9dfaB338bA5D00d42718AC3ef6F0EC3D",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xCb79B743E0fc9BD68e7741F8C756952C8025879e",
            txs: [
              {
                walletAddress: "0xCb79B743E0fc9BD68e7741F8C756952C8025879e",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x9Cc90eFb89f3F69B3652E5a071617c6B77622483",
            txs: [
              {
                walletAddress: "0x9Cc90eFb89f3F69B3652E5a071617c6B77622483",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x70451fbFC7CF3fbD62e7A8a707CE9DEc78eAc345",
            txs: [
              {
                walletAddress: "0x70451fbFC7CF3fbD62e7A8a707CE9DEc78eAc345",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x3e4aD1317Aa2B9122a39fF11982d97A4ed44a5c0",
            txs: [
              {
                walletAddress: "0x3e4aD1317Aa2B9122a39fF11982d97A4ed44a5c0",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xAFe513B94C1Aa51342213eE862cE05484CC53381",
            txs: [
              {
                walletAddress: "0xAFe513B94C1Aa51342213eE862cE05484CC53381",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xa3Ac183b692B57dB68323fA1a85E64EBEFDADCBc",
            txs: [
              {
                walletAddress: "0xa3Ac183b692B57dB68323fA1a85E64EBEFDADCBc",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x5453f79BC655F5B8F85869476F7BFdcC343A8138",
            txs: [
              {
                walletAddress: "0x5453f79BC655F5B8F85869476F7BFdcC343A8138",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x178A506c75959FE8e9f2fE3896Cf3b5Aaa14eACE",
            txs: [
              {
                walletAddress: "0x178A506c75959FE8e9f2fE3896Cf3b5Aaa14eACE",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x87A09bef77c381aDC4f69D12A593A3a2604b13d1",
            txs: [
              {
                walletAddress: "0x87A09bef77c381aDC4f69D12A593A3a2604b13d1",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xF9A0106251467FFF1Ff03e8609aa74fc55A2a45E",
            txs: [
              {
                walletAddress: "0xF9A0106251467FFF1Ff03e8609aa74fc55A2a45E",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x8B1A34A77FEB571e8d8b18DF268715D3D14f3fbB",
            txs: [
              {
                walletAddress: "0x8B1A34A77FEB571e8d8b18DF268715D3D14f3fbB",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x35d77FA0B5515dA6ba1358E7ecc83e46557a7253",
            txs: [
              {
                walletAddress: "0x35d77FA0B5515dA6ba1358E7ecc83e46557a7253",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xf2EB0E1D36d7e23045ceF8B7232797e5DE7f4B54",
            txs: [
              {
                walletAddress: "0xf2EB0E1D36d7e23045ceF8B7232797e5DE7f4B54",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x29aBD9AECbdaD4f19D6E2c0d58E51B323cfCc582",
            txs: [
              {
                walletAddress: "0x29aBD9AECbdaD4f19D6E2c0d58E51B323cfCc582",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x5BAF04E2c1e6604597A27087d946b9afe2A05c00",
            txs: [
              {
                walletAddress: "0x5BAF04E2c1e6604597A27087d946b9afe2A05c00",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xfDaD3a767DE7536a4Bf8B9a044cF562Ca6272249",
            txs: [
              {
                walletAddress: "0xfDaD3a767DE7536a4Bf8B9a044cF562Ca6272249",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xc8b00d5Af3E2CBe9d07e734A2b9b9b32d92b5E48",
            txs: [
              {
                walletAddress: "0xc8b00d5Af3E2CBe9d07e734A2b9b9b32d92b5E48",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x21d80309bE847D4cF82C7c3A4C5d9635c7b051e6",
            txs: [
              {
                walletAddress: "0x21d80309bE847D4cF82C7c3A4C5d9635c7b051e6",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x62548D06CeaAf850798A909e5fD8B4459E5704b0",
            txs: [
              {
                walletAddress: "0x62548D06CeaAf850798A909e5fD8B4459E5704b0",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xbE0D4696bADCF24505229819877da185eaB751Ba",
            txs: [
              {
                walletAddress: "0xbE0D4696bADCF24505229819877da185eaB751Ba",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xa33698123eFD6C3Ec31079db0fAE09d399160560",
            txs: [
              {
                walletAddress: "0xa33698123eFD6C3Ec31079db0fAE09d399160560",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x000f3DC066Fa6C8ff69a931BCea25D11A21dF3d3",
            txs: [
              {
                walletAddress: "0x000f3DC066Fa6C8ff69a931BCea25D11A21dF3d3",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
              {
                walletAddress: "0x000f3DC066Fa6C8ff69a931BCea25D11A21dF3d3",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
              {
                walletAddress: "0x000f3DC066Fa6C8ff69a931BCea25D11A21dF3d3",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xC72E13B41E18998E115f2cfF0d4549798A91D07E",
            txs: [
              {
                walletAddress: "0xC72E13B41E18998E115f2cfF0d4549798A91D07E",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xB6d417751b219cF685303BE3c513D695fA9766CC",
            txs: [
              {
                walletAddress: "0xB6d417751b219cF685303BE3c513D695fA9766CC",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xC4213ffb2c152fd9687bBDb97b8F49A307Ad9a47",
            txs: [
              {
                walletAddress: "0xC4213ffb2c152fd9687bBDb97b8F49A307Ad9a47",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x975f277BF7b0F5d13A9A78C5578932855C42a332",
            txs: [
              {
                walletAddress: "0x975f277BF7b0F5d13A9A78C5578932855C42a332",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xC59767942DF71a9f055EDC6f69e9906c91D27717",
            txs: [
              {
                walletAddress: "0xC59767942DF71a9f055EDC6f69e9906c91D27717",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x671925a6458AC7e39Af1601513878131139805DD",
            txs: [
              {
                walletAddress: "0x671925a6458AC7e39Af1601513878131139805DD",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xCaD093b2D71b3A2508452D67747a7b577782cA64",
            txs: [
              {
                walletAddress: "0xCaD093b2D71b3A2508452D67747a7b577782cA64",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x77D352647BD6054CE541Ee9c08f2830cf31b878f",
            txs: [
              {
                walletAddress: "0x77D352647BD6054CE541Ee9c08f2830cf31b878f",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x5d6FD339AdC2a5fF7a6D370d2AAb4DB6937548d8",
            txs: [
              {
                walletAddress: "0x5d6FD339AdC2a5fF7a6D370d2AAb4DB6937548d8",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x1C7346A1933152c180c51F729075900D1b449BC3",
            txs: [
              {
                walletAddress: "0x1C7346A1933152c180c51F729075900D1b449BC3",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x48327ead3CF46364A3d62C26De6F8bf596b0C97A",
            txs: [
              {
                walletAddress: "0x48327ead3CF46364A3d62C26De6F8bf596b0C97A",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x3778910e4F2B799063651fe4b9b3F4e17578fb07",
            txs: [
              {
                walletAddress: "0x3778910e4F2B799063651fe4b9b3F4e17578fb07",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xBc0CBfc04fB4DEb175effc652bbe7f06Bb7c3d25",
            txs: [
              {
                walletAddress: "0xBc0CBfc04fB4DEb175effc652bbe7f06Bb7c3d25",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x6D254C6C931C254a95c3927A5536BD640AfaFc8d",
            txs: [
              {
                walletAddress: "0x6D254C6C931C254a95c3927A5536BD640AfaFc8d",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xE794d2c807E2C82E933705abC341ad8E4Ada599c",
            txs: [
              {
                walletAddress: "0xE794d2c807E2C82E933705abC341ad8E4Ada599c",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xC053b676b5DAaEe9037BCC0Dc6104313B26C9B77",
            txs: [
              {
                walletAddress: "0xC053b676b5DAaEe9037BCC0Dc6104313B26C9B77",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x4f5605A53d3b986B5d28235ec0D761783455C390",
            txs: [
              {
                walletAddress: "0x4f5605A53d3b986B5d28235ec0D761783455C390",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x063ADACc01dB782093d0310bf3d5755d2aDEc424",
            txs: [
              {
                walletAddress: "0x063ADACc01dB782093d0310bf3d5755d2aDEc424",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x617f589346B296E98eC4d2DfA30285f44A9b4048",
            txs: [
              {
                walletAddress: "0x617f589346B296E98eC4d2DfA30285f44A9b4048",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x03D13E3f203DA97B5c6c8Cc914471Debe40dD2D6",
            txs: [
              {
                walletAddress: "0x03D13E3f203DA97B5c6c8Cc914471Debe40dD2D6",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x7765707b821b985B80766A3B14eE3f280961C4D9",
            txs: [
              {
                walletAddress: "0x7765707b821b985B80766A3B14eE3f280961C4D9",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x5c12374f921A5bfC233A4bc661ae74F5B7034158",
            txs: [
              {
                walletAddress: "0x5c12374f921A5bfC233A4bc661ae74F5B7034158",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xB897061deE2C73c0Ac39c8e34aA459f67CEDb1c3",
            txs: [
              {
                walletAddress: "0xB897061deE2C73c0Ac39c8e34aA459f67CEDb1c3",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x2E1B895e0397226c1617e887A1ac75a6209EDc19",
            txs: [
              {
                walletAddress: "0x2E1B895e0397226c1617e887A1ac75a6209EDc19",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x2847D9a0f6C9289246d225c18128acA51E4bedc9",
            txs: [
              {
                walletAddress: "0x2847D9a0f6C9289246d225c18128acA51E4bedc9",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x45e58784A1A00Ca6DF3889ea698CA68684Fed3C0",
            txs: [
              {
                walletAddress: "0x45e58784A1A00Ca6DF3889ea698CA68684Fed3C0",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xff74F990eA98708405B2D56B00A36b1595A405E4",
            txs: [
              {
                walletAddress: "0xff74F990eA98708405B2D56B00A36b1595A405E4",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x49D87959559632daE2d9bc5C67A7dee43cD5757b",
            txs: [
              {
                walletAddress: "0x49D87959559632daE2d9bc5C67A7dee43cD5757b",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xf8586C8C892c2Ee72e08c71bE01a29b749e06386",
            txs: [
              {
                walletAddress: "0xf8586C8C892c2Ee72e08c71bE01a29b749e06386",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x2Bd6c3d9b25029C82a193d3a79279deF3aAe2D11",
            txs: [
              {
                walletAddress: "0x2Bd6c3d9b25029C82a193d3a79279deF3aAe2D11",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x4Ade5f538F1143bf80DB6c6053D323F7ACFD43D9",
            txs: [
              {
                walletAddress: "0x4Ade5f538F1143bf80DB6c6053D323F7ACFD43D9",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x24eC21C5a0b462fa4a2C8fd2F4238644E3D798C3",
            txs: [
              {
                walletAddress: "0x24eC21C5a0b462fa4a2C8fd2F4238644E3D798C3",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xEd6c18C62c7B81ee63C502E7375cBb9A30d56b6C",
            txs: [
              {
                walletAddress: "0xEd6c18C62c7B81ee63C502E7375cBb9A30d56b6C",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x5571cDF395d67848056b22Cb725542756481588b",
            txs: [
              {
                walletAddress: "0x5571cDF395d67848056b22Cb725542756481588b",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x02592226BAA816659F3212bfE71Fe3bCeC3A6185",
            txs: [
              {
                walletAddress: "0x02592226BAA816659F3212bfE71Fe3bCeC3A6185",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x9188AC0edaaCCF82b2c18EE91aBaa5Db868b35Ed",
            txs: [
              {
                walletAddress: "0x9188AC0edaaCCF82b2c18EE91aBaa5Db868b35Ed",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xB79A48cdFB85d1Ac45989f40793aBc7A1A15C5e3",
            txs: [
              {
                walletAddress: "0xB79A48cdFB85d1Ac45989f40793aBc7A1A15C5e3",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x761AF9Bb297f82195C4113E193e8394d26d4C8a1",
            txs: [
              {
                walletAddress: "0x761AF9Bb297f82195C4113E193e8394d26d4C8a1",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x199aebB33244840049A4710169d3D6CF4bDfE2E6",
            txs: [
              {
                walletAddress: "0x199aebB33244840049A4710169d3D6CF4bDfE2E6",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xd47a605c732654cd8D29e02DA3A79EB55E1f912b",
            txs: [
              {
                walletAddress: "0xd47a605c732654cd8D29e02DA3A79EB55E1f912b",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x2a748e0f55c9a1a92F0E96Fc5d3527A2c86238f2",
            txs: [
              {
                walletAddress: "0x2a748e0f55c9a1a92F0E96Fc5d3527A2c86238f2",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xd1c921829db71034B077E585FA4F28850F2b5267",
            txs: [
              {
                walletAddress: "0xd1c921829db71034B077E585FA4F28850F2b5267",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x0f04fCaEff015F599d5236e7BD712A5Bc2d3ab7f",
            txs: [
              {
                walletAddress: "0x0f04fCaEff015F599d5236e7BD712A5Bc2d3ab7f",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x0C07fC4F70348C5DE11cA5C1b99318EC7ABeB4CA",
            txs: [
              {
                walletAddress: "0x0C07fC4F70348C5DE11cA5C1b99318EC7ABeB4CA",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xF8Bd571A457684A553270445eBd7e80F3f362B5E",
            txs: [
              {
                walletAddress: "0xF8Bd571A457684A553270445eBd7e80F3f362B5E",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x839c92fC98A8EeAB03047Cf851b98822fA58b8d4",
            txs: [
              {
                walletAddress: "0x839c92fC98A8EeAB03047Cf851b98822fA58b8d4",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x9c2F3E6C6E001E88a99eDd8717B85c11f5aD92F3",
            txs: [
              {
                walletAddress: "0x9c2F3E6C6E001E88a99eDd8717B85c11f5aD92F3",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x15121CE979D75C2e104b22B24Ba414D7ae1246BD",
            txs: [
              {
                walletAddress: "0x15121CE979D75C2e104b22B24Ba414D7ae1246BD",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xE7647BF421c9c728dEdD5664f54cA98D2bB77443",
            txs: [
              {
                walletAddress: "0xE7647BF421c9c728dEdD5664f54cA98D2bB77443",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xBf0F1A907967cAbdDf946693155C71D174bFf7dE",
            txs: [
              {
                walletAddress: "0xBf0F1A907967cAbdDf946693155C71D174bFf7dE",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x9c6551D046f6865a1Da98D6fd2884991baaDf41E",
            txs: [
              {
                walletAddress: "0x9c6551D046f6865a1Da98D6fd2884991baaDf41E",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x9E50e6D7f97A82Eb0073b9C6c3118f1254D64544",
            txs: [
              {
                walletAddress: "0x9E50e6D7f97A82Eb0073b9C6c3118f1254D64544",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
              {
                walletAddress: "0x9E50e6D7f97A82Eb0073b9C6c3118f1254D64544",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x53299f326DFced4f9f99c5e5b77BE66D42B1c4Cd",
            txs: [
              {
                walletAddress: "0x53299f326DFced4f9f99c5e5b77BE66D42B1c4Cd",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xf4676e7688AbABDce69e9cCFa9a1d2D79AE70daB",
            txs: [
              {
                walletAddress: "0xf4676e7688AbABDce69e9cCFa9a1d2D79AE70daB",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x064b1411A3dD51EAA41f9c694Ff468706890E335",
            txs: [
              {
                walletAddress: "0x064b1411A3dD51EAA41f9c694Ff468706890E335",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xBD03d3b81509aA43180Cd185D878641C305B323b",
            txs: [
              {
                walletAddress: "0xBD03d3b81509aA43180Cd185D878641C305B323b",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
        ],
      },
      {
        referer: "https://scroll.io/",
        totalUser: 307,
        walletsConnected: 215,
        objectiveAchieved: 11,
        achievedWallets: [
          {
            walletAddress: "0xA2ea4EA5e428a8468718C76e0F8c7fE833dE0265",
            txs: [
              {
                walletAddress: "0xA2ea4EA5e428a8468718C76e0F8c7fE833dE0265",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x845d02A5FD9496Defb079E25c433f1C77Efdd741",
            txs: [
              {
                walletAddress: "0x845d02A5FD9496Defb079E25c433f1C77Efdd741",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x2ce19B88b1407a30526b349505468CA9376ddADB",
            txs: [
              {
                walletAddress: "0x2ce19B88b1407a30526b349505468CA9376ddADB",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xB4a6d29844d54a96be120f8d750B39C6bc2C1045",
            txs: [
              {
                walletAddress: "0xB4a6d29844d54a96be120f8d750B39C6bc2C1045",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x103F4262f5472Cd6C6a5366c9597d22C44F08105",
            txs: [
              {
                walletAddress: "0x103F4262f5472Cd6C6a5366c9597d22C44F08105",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x1587ffd30408BA76875fBa8Ea9c3a2A8E72Fa9ef",
            txs: [
              {
                walletAddress: "0x1587ffd30408BA76875fBa8Ea9c3a2A8E72Fa9ef",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x2d13Dc5DD3F72fDE8A5120C0820c2624F43E9C22",
            txs: [
              {
                walletAddress: "0x2d13Dc5DD3F72fDE8A5120C0820c2624F43E9C22",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xd6CF883E96fc44B2A34dAF73D6bD859CC27DCb6b",
            txs: [
              {
                walletAddress: "0xd6CF883E96fc44B2A34dAF73D6bD859CC27DCb6b",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x434e52764a1e19868807669457f1813E321E3f24",
            txs: [
              {
                walletAddress: "0x434e52764a1e19868807669457f1813E321E3f24",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x665bd7E5CEF57cf535268ADF3df53f20115A9dAa",
            txs: [
              {
                walletAddress: "0x665bd7E5CEF57cf535268ADF3df53f20115A9dAa",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xE52f576Dd92DaC70c9d396C39316dF040BFfCc60",
            txs: [
              {
                walletAddress: "0xE52f576Dd92DaC70c9d396C39316dF040BFfCc60",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
        ],
      },
      {
        referer: "https://www.google.com/",
        totalUser: 223,
        walletsConnected: 140,
        objectiveAchieved: 9,
        achievedWallets: [
          {
            walletAddress: "0x95b4517e39c6F619aAEe6eE558abA1eB605E1E4A",
            txs: [
              {
                walletAddress: "0x95b4517e39c6F619aAEe6eE558abA1eB605E1E4A",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xeC2A9172034Db9451a6c5c5fEaaa22edD7D6AF16",
            txs: [
              {
                walletAddress: "0xeC2A9172034Db9451a6c5c5fEaaa22edD7D6AF16",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xa182FAC9E3891DFbebf4011a6AD60A6b3463D1d4",
            txs: [
              {
                walletAddress: "0xa182FAC9E3891DFbebf4011a6AD60A6b3463D1d4",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x91DC314e8b095D8A0D04cA5353b4aB3B3A2B86F2",
            txs: [
              {
                walletAddress: "0x91DC314e8b095D8A0D04cA5353b4aB3B3A2B86F2",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xf5d9493820B4f744bDDEA3394146EcFb88de6d65",
            txs: [
              {
                walletAddress: "0xf5d9493820B4f744bDDEA3394146EcFb88de6d65",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x9F8AF0Bef30D33811aEDB08f5E642d7b0a176c32",
            txs: [
              {
                walletAddress: "0x9F8AF0Bef30D33811aEDB08f5E642d7b0a176c32",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xA467c0A0F41A2E689580C26FC647d7EC883Fc404",
            txs: [
              {
                walletAddress: "0xA467c0A0F41A2E689580C26FC647d7EC883Fc404",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x73B1B64B152F61E37137f14F62A8D294A75F25f2",
            txs: [
              {
                walletAddress: "0x73B1B64B152F61E37137f14F62A8D294A75F25f2",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x06166647DE6a661e52bc26d50B17ee8f95a0ECDa",
            txs: [
              {
                walletAddress: "0x06166647DE6a661e52bc26d50B17ee8f95a0ECDa",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
        ],
      },
      {
        referer:
          "https://kelpdao.xyz?utm_source=0x98D62Dd170D9B8979bDdb98AE6bb6f7640A82AD3",
        totalUser: 111,
        walletsConnected: 79,
        objectiveAchieved: 4,
        achievedWallets: [
          {
            walletAddress: "0xf6599984411f3c39196e3C796fcA70b79ef11f02",
            txs: [
              {
                walletAddress: "0xf6599984411f3c39196e3C796fcA70b79ef11f02",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xBEbC82023348c9dAFE4a3BD054f2d8098CB2c37C",
            txs: [
              {
                walletAddress: "0xBEbC82023348c9dAFE4a3BD054f2d8098CB2c37C",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0xf17F53eda987b3f831d32F99Beee467512e130D0",
            txs: [
              {
                walletAddress: "0xf17F53eda987b3f831d32F99Beee467512e130D0",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
          {
            walletAddress: "0x8Ce01CF638681e12AFfD10e2feb1E7E3C50b7509",
            txs: [
              {
                walletAddress: "0x8Ce01CF638681e12AFfD10e2feb1E7E3C50b7509",
                txHash:
                  "0x4f82206d85498b7892f97edeecd04df1042157eed49f976aac593124ac0f6769",
                chainId: 137,
                timestamp: "2024-08-30T07:17:54.000Z",
              },
            ],
          },
        ],
      },
      {
        referer: "https://www.kelpdao.xyz?utm_source=turtle",
        totalUser: 93,
        walletsConnected: 71,
        objectiveAchieved: 0,
        achievedWallets: [],
      },
    ],
  },
  allCharts: {
    success: true,
    osData: [
      {
        totalUser: 2480,
        walletsConnected: 1738,
        objectiveAchieved: 88,
        os: "Windows",
      },
      {
        totalUser: 699,
        walletsConnected: 506,
        objectiveAchieved: 32,
        os: "macOS",
      },
      {
        totalUser: 641,
        walletsConnected: 213,
        objectiveAchieved: 17,
        os: "Others",
      },
      {
        totalUser: 341,
        walletsConnected: 219,
        objectiveAchieved: 19,
        os: "Android",
      },
      {
        totalUser: 65,
        walletsConnected: 53,
        objectiveAchieved: 4,
        os: "Linux",
      },
      {
        totalUser: 10,
        walletsConnected: 3,
        objectiveAchieved: 0,
        os: "Chrome OS",
      },
    ],
    browserData: [
      {
        totalUser: 2706,
        walletsConnected: 1844,
        objectiveAchieved: 100,
        browser: "Chrome",
      },
      {
        totalUser: 1022,
        walletsConnected: 498,
        objectiveAchieved: 38,
        browser: "Other",
      },
      {
        totalUser: 386,
        walletsConnected: 313,
        objectiveAchieved: 20,
        browser: "Brave",
      },
      {
        totalUser: 122,
        walletsConnected: 77,
        objectiveAchieved: 2,
        browser: "Edge",
      },
    ],
    deviceData: [
      {
        totalUser: 3271,
        walletsConnected: 2305,
        objectiveAchieved: 125,
        device: "Desktop",
      },
      {
        totalUser: 638,
        walletsConnected: 213,
        objectiveAchieved: 17,
        device: "Other",
      },
      {
        totalUser: 327,
        walletsConnected: 214,
        objectiveAchieved: 18,
        device: "Mobile",
      },
    ],
    countryData: [
      {
        country: "Others",
        name: "Others",
        totalUser: 4115,
        walletsConnected: 2641,
        objectiveAchieved: 153,
      },
      {
        country: "IND",
        name: "India",
        totalUser: 21,
        walletsConnected: 15,
        objectiveAchieved: 1,
      },
      {
        country: "HKG",
        name: "Hong Kong",
        totalUser: 10,
        walletsConnected: 4,
        objectiveAchieved: 1,
      },
      {
        country: "FRA",
        name: "France",
        totalUser: 7,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "TUR",
        name: "Turkey",
        totalUser: 6,
        walletsConnected: 6,
        objectiveAchieved: 1,
      },
      {
        country: "JPN",
        name: "Japan",
        totalUser: 6,
        walletsConnected: 6,
        objectiveAchieved: 1,
      },
      {
        country: "CHE",
        name: "Switzerland",
        totalUser: 6,
        walletsConnected: 6,
        objectiveAchieved: 0,
      },
      {
        country: "ESP",
        name: "Spain",
        totalUser: 5,
        walletsConnected: 5,
        objectiveAchieved: 0,
      },
      {
        country: "SAU",
        name: "Saudi Arabia",
        totalUser: 4,
        walletsConnected: 4,
        objectiveAchieved: 0,
      },
      {
        country: "IDN",
        name: "Indonesia",
        totalUser: 4,
        walletsConnected: 4,
        objectiveAchieved: 0,
      },
      {
        country: "USA",
        name: "United States",
        totalUser: 3,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "NLD",
        name: "Netherlands",
        totalUser: 3,
        walletsConnected: 3,
        objectiveAchieved: 0,
      },
      {
        country: "GBR",
        name: "United Kingdom",
        totalUser: 3,
        walletsConnected: 3,
        objectiveAchieved: 2,
      },
      {
        country: "UKR",
        name: "Ukraine",
        totalUser: 3,
        walletsConnected: 2,
        objectiveAchieved: 0,
      },
      {
        country: "DEU",
        name: "Germany",
        totalUser: 3,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "PHL",
        name: "Philippines",
        totalUser: 3,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "SGP",
        name: "Singapore",
        totalUser: 3,
        walletsConnected: 3,
        objectiveAchieved: 0,
      },
      {
        country: "BRA",
        name: "Brazil",
        totalUser: 3,
        walletsConnected: 3,
        objectiveAchieved: 0,
      },
      {
        country: "AUS",
        name: "Australia",
        totalUser: 3,
        walletsConnected: 3,
        objectiveAchieved: 0,
      },
      {
        country: "CMR",
        name: "Cameroon",
        totalUser: 2,
        walletsConnected: 2,
        objectiveAchieved: 1,
      },
      {
        country: "TWN",
        name: "Taiwan",
        totalUser: 2,
        walletsConnected: 2,
        objectiveAchieved: 0,
      },
      {
        country: "KOR",
        name: "South Korea",
        totalUser: 2,
        walletsConnected: 0,
        objectiveAchieved: 0,
      },
      {
        country: "COL",
        name: "Colombia",
        totalUser: 2,
        walletsConnected: 2,
        objectiveAchieved: 0,
      },
      {
        country: "ARG",
        name: "Argentina",
        totalUser: 2,
        walletsConnected: 2,
        objectiveAchieved: 0,
      },
      {
        country: "NGA",
        name: "Nigeria",
        totalUser: 2,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "BHR",
        name: "Bahrain",
        totalUser: 2,
        walletsConnected: 2,
        objectiveAchieved: 0,
      },
      {
        country: "RUS",
        name: "Russia",
        totalUser: 2,
        walletsConnected: 2,
        objectiveAchieved: 0,
      },
      {
        country: "KHM",
        name: "Cambodia",
        totalUser: 1,
        walletsConnected: 0,
        objectiveAchieved: 0,
      },
      {
        country: "BEL",
        name: "Belgium",
        totalUser: 1,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "PRY",
        name: "Paraguay",
        totalUser: 1,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "ARE",
        name: "United Arab Emirates",
        totalUser: 1,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "MAR",
        name: "Morocco",
        totalUser: 1,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "KAZ",
        name: "Kazakhstan",
        totalUser: 1,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "ZAF",
        name: "South Africa",
        totalUser: 1,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
      {
        country: "ROU",
        name: "Romania",
        totalUser: 1,
        walletsConnected: 0,
        objectiveAchieved: 0,
      },
      {
        country: "BGD",
        name: "Bangladesh",
        totalUser: 1,
        walletsConnected: 1,
        objectiveAchieved: 0,
      },
    ],
  },
  lineChart: {
    success: true,
    campaignPerformance: [
      {
        totalUser: 3162,
        walletsConnected: 2995,
        objectiveAchieved: 314,
        date: "2024-12-4",
      },
      {
        totalUser: 1074,
        walletsConnected: 737,
        objectiveAchieved: 46,
        date: "2024-12-5",
      },
      {
        totalUser: 1774,
        walletsConnected: 637,
        objectiveAchieved: 146,
        date: "2024-12-6",
      },
      {
        totalUser: 104,
        walletsConnected: 37,
        objectiveAchieved: 26,
        date: "2024-12-7",
      },
      {
        totalUser: 3074,
        walletsConnected: 1737,
        objectiveAchieved: 246,
        date: "2024-12-8",
      },
      {
        totalUser: 1474,
        walletsConnected: 337,
        objectiveAchieved: 436,
        date: "2024-12-9",
      },
      {
        totalUser: 2274,
        walletsConnected: 227,
        objectiveAchieved: 226,
        date: "2024-12-10",
      },
    ],
  },
  trackingStats: {
    sessionCount: 12936,
    sessionGrowth: 56.382488903622665,
    uniqueWalletCount: 8732,
    uniqueWalletGrowth: 53.58528676978685,
    newWalletCount: 4231,
    newWalletGrowth: 64.65735097368812,
    objectiveAchieved: 1840,
    objectiveAchievedGrowth: 13,
    convertionRate: 13.1,
    convertionRateGrowth: 2,
  },
  walletAnalysis: {
    totalWalletSum: 11493,
    newWalletSum: 4755,
    returningWalletSum: 6738,
    data: [
      {
        date: "2024/12/12",
        totalWallets: 2380,
        newWallets: 1010,
        returningWallets: 1370,
      },
      {
        date: "2024/12/13",
        totalWallets: 2051,
        newWallets: 849,
        returningWallets: 1202,
      },
      {
        date: "2024/12/14",
        totalWallets: 1858,
        newWallets: 799,
        returningWallets: 1059,
      },
      {
        date: "2024/12/15",
        totalWallets: 1856,
        newWallets: 809,
        returningWallets: 1047,
      },
      {
        date: "2024/12/16",
        totalWallets: 1902,
        newWallets: 753,
        returningWallets: 1149,
      },
      {
        date: "2024/12/17",
        totalWallets: 1446,
        newWallets: 535,
        returningWallets: 911,
      },
      {
        date: "2024/12/18",
        totalWallets: "N/A",
        newWallets: "N/A",
        returningWallets: "N/A",
      },
    ],
  },
  userMatrix: {
    sessionSum: 23683,
    uniqueWalletSum: 8732,
    data: [
      {
        date: "2024/12/12",
        sessionCount: 5579,
        uniqueWallets: 2380,
      },
      {
        date: "2024/12/13",
        sessionCount: 4275,
        uniqueWallets: 1628,
      },
      {
        date: "2024/12/14",
        sessionCount: 3654,
        uniqueWallets: 1352,
      },
      {
        date: "2024/12/15",
        sessionCount: 3602,
        uniqueWallets: 1308,
      },
      {
        date: "2024/12/16",
        sessionCount: 3918,
        uniqueWallets: 1223,
      },
      {
        date: "2024/12/17",
        sessionCount: 2655,
        uniqueWallets: 841,
      },
      {
        date: "2024/12/18",
        sessionCount: "N/A",
        uniqueWallets: "N/A",
      },
    ],
  },
  cohortRetention: {
    data: {
      "2024/12/12": [1009, 70, 36, 44, 49, 41, 0],
      "2024/12/13": [849, 55, 41, 32, 24, 0],
      "2024/12/14": [799, 70, 40, 22, 0],
      "2024/12/15": [809, 62, 34, 0],
      "2024/12/16": [753, 56, 0],
      "2024/12/17": [535, 0],
      "2024/12/18": ["N/A"],
    },
  },
  objectivesBreakdown: {
    currentMetrics: {
      "Objective #1 AssetDeposit": 17,
      "Objective #2 ETHDeposit": 21,
      "Objective #3 SwapETH": 66,
      "Objective #4 SwapUSDT": 0,
      "Objective #5 SwapUSDC": 168,
      "Objective #6 StakedETH": 57,
      "Objective #7 StakedUSDT": 562,
      "Objective #8 StakedUSDC": 16,
      "Objective #9 RSETHMintedAndDepositedInVault": 28,
      "Objective #10 TransferETH": 0,
      "Objective #11 TransferUSDT": 0,
    },
    growthMetrics: {
      "Objective #1 AssetDeposit": 22,
      "Objective #2 ETHDeposit": 10,
      "Objective #3 SwapETH": -8,
      "Objective #4 SwapUSDT": 3,
      "Objective #5 SwapUSDC": -5,
      "Objective #6 StakedETH": 20,
      "Objective #7 StakedUSDT": 200,
      "Objective #8 StakedUSDC": -3,
      "Objective #9 RSETHMintedAndDepositedInVault": 16,
      "Objective #10 TransferETH": "-",
      "Objective #11 TransferUSDT": "-",
    },
    data: [
      {
        date: "2024/12/12",
        "Objective #1 AssetDeposit": 1,
        "Objective #2 ETHDeposit": 3,
        "Objective #3 SwapETH": 4,
        "Objective #4 SwapUSDT": 0,
        "Objective #5 SwapUSDC": 14,
        "Objective #6 StakedETH": 6,
        "Objective #7 StakedUSDT": 87,
        "Objective #8 StakedUSDC": 1,
        "Objective #9 RSETHMintedAndDepositedInVault": 0,
        "Objective #10 TransferETH": 0,
        "Objective #11 TransferUSDT": 0,
      },
      {
        date: "2024/12/13",
        "Objective #1 AssetDeposit": 2,
        "Objective #2 ETHDeposit": 1,
        "Objective #3 SwapETH": 34,
        "Objective #4 SwapUSDT": 0,
        "Objective #5 SwapUSDC": 38,
        "Objective #6 StakedETH": 7,
        "Objective #7 StakedUSDT": 129,
        "Objective #8 StakedUSDC": 2,
        "Objective #9 RSETHMintedAndDepositedInVault": 6,
        "Objective #10 TransferETH": 0,
        "Objective #11 TransferUSDT": 0,
      },
      {
        date: "2024/12/14",
        "Objective #1 AssetDeposit": 9,
        "Objective #2 ETHDeposit": 3,
        "Objective #3 SwapETH": 11,
        "Objective #4 SwapUSDT": 0,
        "Objective #5 SwapUSDC": 30,
        "Objective #6 StakedETH": 9,
        "Objective #7 StakedUSDT": 107,
        "Objective #8 StakedUSDC": 3,
        "Objective #9 RSETHMintedAndDepositedInVault": 10,
        "Objective #10 TransferETH": 0,
        "Objective #11 TransferUSDT": 0,
      },
      {
        date: "2024/12/15",
        "Objective #1 AssetDeposit": 1,
        "Objective #2 ETHDeposit": 12,
        "Objective #3 SwapETH": 8,
        "Objective #4 SwapUSDT": 0,
        "Objective #5 SwapUSDC": 37,
        "Objective #6 StakedETH": 18,
        "Objective #7 StakedUSDT": 117,
        "Objective #8 StakedUSDC": 4,
        "Objective #9 RSETHMintedAndDepositedInVault": 7,
        "Objective #10 TransferETH": 0,
        "Objective #11 TransferUSDT": 0,
      },
      {
        date: "2024/12/16",
        "Objective #1 AssetDeposit": 0,
        "Objective #2 ETHDeposit": 2,
        "Objective #3 SwapETH": 5,
        "Objective #4 SwapUSDT": 0,
        "Objective #5 SwapUSDC": 39,
        "Objective #6 StakedETH": 12,
        "Objective #7 StakedUSDT": 84,
        "Objective #8 StakedUSDC": 6,
        "Objective #9 RSETHMintedAndDepositedInVault": 3,
        "Objective #10 TransferETH": 0,
        "Objective #11 TransferUSDT": 0,
      },
      {
        date: "2024/12/17",
        "Objective #1 AssetDeposit": 4,
        "Objective #2 ETHDeposit": 0,
        "Objective #3 SwapETH": 4,
        "Objective #4 SwapUSDT": 0,
        "Objective #5 SwapUSDC": 10,
        "Objective #6 StakedETH": 5,
        "Objective #7 StakedUSDT": 38,
        "Objective #8 StakedUSDC": 0,
        "Objective #9 RSETHMintedAndDepositedInVault": 2,
        "Objective #10 TransferETH": 0,
        "Objective #11 TransferUSDT": 0,
      },
      {
        date: "2024/12/18",
        "Objective #1 AssetDeposit": "N/A",
        "Objective #2 ETHDeposit": "N/A",
        "Objective #3 SwapETH": "N/A",
        "Objective #4 SwapUSDT": "N/A",
        "Objective #5 SwapUSDC": "N/A",
        "Objective #6 StakedETH": "N/A",
        "Objective #7 StakedUSDT": "N/A",
        "Objective #8 StakedUSDC": "N/A",
        "Objective #9 RSETHMintedAndDepositedInVault": "N/A",
        "Objective #10 TransferETH": "N/A",
        "Objective #11 TransferUSDT": "N/A",
      },
    ],
  },
};
